/**
 * Item classification enums — barcode, substitute, and return behaviour lookups.
 * Item classes and material groups are loaded from API master screens.
 */

export const BARCODE_TYPES = [
  { value: 'EAN13',    label: 'EAN-13' },
  { value: 'EAN8',     label: 'EAN-8' },
  { value: 'CODE128',  label: 'Code 128' },
  { value: 'QR',       label: 'QR Code' },
  { value: 'VENDOR',   label: 'Vendor barcode' },
  { value: 'INTERNAL', label: 'Internal' },
];

export const SUBSTITUTE_TYPES = [
  { value: 'GENERIC',      label: 'Generic equivalent' },
  { value: 'THERAPEUTIC',  label: 'Therapeutic equivalent' },
  { value: 'BRAND',        label: 'Brand alternate' },
  { value: 'PACK',         label: 'Different pack size' },
];

export const RETURN_BEHAVIORS = [
  { value: 'REFUND',       label: 'Refund' },
  { value: 'REPLACEMENT',  label: 'Replacement' },
  { value: 'NONE',         label: 'Not returnable' },
];

// GST rate options moved to constants/taxMaster.js — GST is now derived from
// the Tax Master (HSN lookup), not manually selected on the item form.
